import React from "react";

const IconCheckmark = ({ className }) => (
  <svg width="20" height="15" viewBox="0 0 20 15" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M7.722 10.028L2.323 4.581 0 7.01l7.724 7.727L20 2.357 17.666 0z" fill="#417505" fillRule="evenodd" />
  </svg>
);

export default IconCheckmark;
